import { useTranslation } from 'react-i18next';

export const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const isEN = i18n.language === 'en';

  return (
    <button
      onClick={() => i18n.changeLanguage(isEN ? 'ja' : 'en')}
      className="fixed top-4 right-4 z-50 flex items-center gap-1.5 px-3 py-1.5 rounded-full backdrop-blur-sm border border-white/20 text-sm font-medium transition-all hover:scale-105"
      style={{
        backgroundColor: 'rgba(255,255,255,0.15)',
        color: 'white',
        textShadow: '0 1px 3px rgba(0,0,0,0.5)',
      }}
      aria-label="Toggle language"
    >
      <span style={{ opacity: isEN ? 0.45 : 1 }}>JP</span>
      <span style={{ opacity: 0.4 }}>|</span>
      <span style={{ opacity: isEN ? 1 : 0.45 }}>EN</span>
    </button>
  );
};
